import React from "react"
import { useTranslation } from "react-i18next"
import { ExpenseTag } from "~Components/expenseTag"
import { ExpenseTagViewer } from "~Components/popovers/expenseTagViewer.popover"
import { useExpenseTagsByIds } from "~Shared/hooks/expenseTags.hooks"

interface ExpenseTagColumnProps {
    expenseTagIds: Array<string>
}

export const ExpenseTagColumn = ({ expenseTagIds }: ExpenseTagColumnProps) => {
    const expenseTags = useExpenseTagsByIds(expenseTagIds)
    const { t } = useTranslation()

    if (!expenseTags || expenseTags.length === 0) {
        return <> </>
    }

    const [expenseTag1] = expenseTags

    if (expenseTags.length > 1) {
        return (
            <ExpenseTagViewer expenseTags={expenseTags}>
                <ExpenseTag color={expenseTag1.tagColor}> {`(${expenseTags.length}) ${t("label:tags")}`} </ExpenseTag>
            </ExpenseTagViewer>
        )
    }

    return (
        <div className="truncate">
            <ExpenseTag color={expenseTag1.tagColor}>{expenseTag1.tagName} </ExpenseTag>
        </div>
    )
}
